import React, { useRef, useEffect, useState } from 'react';
import './VenetianBlindsText.scss';

const VenetianBlindsText = ({ show, delay = 0 }) => {
  const [visible, setVisible] = useState(false);
  const [spans, setSpans] = useState(0);
  const [lineHeight, setLineHeight] = useState(30);
  const ref = useRef(null);

  useEffect(() => {
    if(delay > 0 && show){
      setTimeout(() => {
        setVisible(show);
      }, delay * 1000);
    } else {
      setVisible(show);
    }
  }, [show]);

  useEffect(() => {
    if (ref.current && ref.current.parentElement) {
      var lHeight = getStyle(ref.current.parentElement, 'line-height');
      setLineHeight(lHeight);
      setTimeout(() => {
        if (ref.current && ref.current.parentElement) {
          setSpans(Math.round(ref.current.parentElement.offsetHeight / lHeight));
        } else {
          setSpans(0);
        }
      }, 500);
    }
  }, [ref]);

  const getStyle = x => {
    let y;
    if (x.currentStyle) {
      y = x.currentStyle['line-height'];
    } else if (window.getComputedStyle) {
      y = document.defaultView.getComputedStyle(x, null).getPropertyValue('line-height');
    }
    if (y.indexOf('px')) {
      y = +y.replace('px', '');
    }
    return y;
  };

  return (
    <span className={`venetian-blinds ${visible ? 'show' : 'hide'}`} ref={ref}>
      {spans
        ? [...Array(spans).keys()].map(i => (
            <span
              className="blind"
              key={i}
              style={{ top: i * lineHeight + 'px', height: (lineHeight*1.1) + 'px' }}
            />
          ))
        : null}
    </span>
  );
};

export default VenetianBlindsText;
